const ANY_TYPE = "any";
const INCUMBENT = "incumbent";
const CHALLENGER = "challenger";

export default {
  ANY_TYPE,
  INCUMBENT,
  CHALLENGER
};
